export enum TherapistClientUserStatus {
  INVITED = 'Invited',
  ACCOUNT_CREATED = 'Account Created',
  INTAKE_COMPLETE = 'Intake Complete',
  MATCHED = 'Matched',
  REMATCH_REQUESTED = 'Rematch Requested',
  PRE_ONBOARD_STARTED = 'Pre-onboard Started',
  ONBOARDING_PAUSED = 'Onboarding Paused',
  ONBOARDING_FAILED = 'Onboarding Failed',
  FIRST_SESSION_COMPLETE = '1st session complete',
  FIRST_SESSION_SCHEDULED = '1st session scheduled',
  PROFILE_COMPLETE = 'Profile Complete',
  ONBOARDED_MANUALLY = 'Onboarded Manually',
  VERIFIED = 'Verified',
  SESSION_SCHEDULED = 'Session scheduled',
  PAPER_WORK_COMPLETE = 'Paperwork Complete',
  PRE_ONBOARD_COMPLETE = 'Pre-onboard Complete',
  MIGRATED_FROM_EHR = 'Migrated From Ehr',
  PROVIDER_SELF_INVITE = 'Provider Self Invite',
}

export enum TherapistClientUpdatedstatus {
  PAUSED_ONBOARDING = 'PAUSED_ONBOARDING',
  RESUME_ONBOARDING = 'RESUME_ONBOARDING',
  FAILED_ONBOARDING = 'FAILED_ONBOARDING',
  SUCCESSFULL_ONBOARDING = 'SUCCESSFULL_ONBOARDING',
  INPROGRESS_ONBOARDING = 'INPROGRESS_ONBOARDING',
}
